import React from 'react';
import ProfileCard from '@/components/profile/ProfileCard';
import { defaultProfile } from '@/lib/defaults/profileData';
import { useAuth } from '@/context/AuthContext';

export default function ProfilePage() {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  const userProfile = {
    ...defaultProfile,
    name: user?.name || '',
    department: user?.department || '',
    batch: user?.batch || '',
  };

  return (
    <div className="min-h-screen bg-[#f3f2ef] dark:bg-gray-900">
      <ProfileCard initialProfile={userProfile} />
    </div>
  );
}
